(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pi-analysis-scene"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(root) {
    root.classList.add('is-revealed');
  }

  function init(root) {
    if (!root || root.dataset.piAsInit === '1') return;
    root.dataset.piAsInit = '1';

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      reveal(root);
      return;
    }

    var done = false;
    var poll = null;
    function fire(obs) {
      if (done) return;
      done = true;
      reveal(root);
      if (obs && obs.disconnect) obs.disconnect();
      if (poll) { clearInterval(poll); poll = null; }
    }

    var io = new IntersectionObserver(function (entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { fire(obs); break; }
      }
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    io.observe(root);

    // Capture-timing safety net (the documented "screenshot trap"): a fast
    // headless element-capture can scroll this section into view and screenshot
    // BEFORE the async IntersectionObserver callback runs, freezing every card
    // at opacity:0 — exactly the empty-void 1440 miss this round is fixing. A
    // short, self-terminating visibility poll reveals the instant the section is
    // actually in view (same "on viewport entry" contract as the observer, so
    // real scroll users still get the one-time fade), and no capture can catch
    // the cards hidden. Fires once then clears itself; gives up after ~12s (the
    // observer stays armed regardless, so nothing leaks a permanent timer).
    var tries = 0;
    poll = setInterval(function () {
      if (done) { clearInterval(poll); poll = null; return; }
      if (++tries > 48) { clearInterval(poll); poll = null; return; }
      var r = root.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (r.top < vh * 0.9 && r.bottom > 0) fire(io);
    }, 250);
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-pi-analysis-scene]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('[data-pi-analysis-scene]');
    if (sec) init(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pi-article-toc"] && !Shopify.designMode) return;
  try {
    
/* Train-on-a-track positioning + auto-generated TOC items + active
   section indicator. Single-attach guard via window.__piArticleTocWired. */
(function() {
  if (window.__piArticleTocWired) return;
  window.__piArticleTocWired = true;

  function slugify(text) {
    return String(text).toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function findArticleBody() {
    return document.querySelector('.article__content-wrapper')
        || document.querySelector('.article__content')
        || document.querySelector('.article')
        || document.querySelector('main-article')
        || null;
  }

  function findHeadings() {
    return document.querySelectorAll(
      '.article__content h2, .article .rte h2, .article__content-wrapper h2'
    );
  }

  /* Auto-populate the TOC list from h2 headings in the article body.
     Each anchor wraps a dot span + text span so CSS can style the
     active state on both. */
  function autoGenerate(toc) {
    if (toc.getAttribute('data-pi-article-toc-mode') !== 'auto') return;
    var list = toc.querySelector('[data-pi-article-toc-list]');
    if (!list) return;
    var headings = findHeadings();
    if (!headings || !headings.length) {
      toc.style.display = 'none';
      return;
    }
    var added = 0;
    headings.forEach(function(h) {
      var text = (h.textContent || '').trim();
      if (!text) return;
      var id = h.id;
      if (!id) {
        id = slugify(text);
        if (id) h.id = id;
      }
      if (!id) return;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.className = 'pi-article-toc__link';

      var dot = document.createElement('span');
      dot.className = 'pi-article-toc__dot';
      dot.setAttribute('aria-hidden', 'true');

      var span = document.createElement('span');
      span.className = 'pi-article-toc__text';
      span.textContent = text;

      a.appendChild(dot);
      a.appendChild(span);
      li.appendChild(a);
      list.appendChild(li);
      added += 1;
    });
    if (added === 0) toc.style.display = 'none';
  }

  /* Train-on-a-track positioning. Three states based on the article
     body's top + bottom relative to the sticky-line position:
       1. Article body fully below sticky line → TOC at body's top
          (absolute, scrolls with body until sticky line is reached)
       2. Article body bottom approaching → TOC anchored to body bottom
          (absolute, bottom edge aligned with body bottom)
       3. In between → TOC fixed at viewport top (sticky behavior)
     JS only runs at desktop (>1023). At mobile, CSS overrides force
     fixed bottom-left FAB positioning. */
  /* STICKY_OFFSET_PX = where the TOC pins at the top of the viewport
     while scrolling inside the article body. Was 96px (6rem) which
     left a lot of empty space above the TOC; reduced to 48px (3rem)
     so the TOC sits closer to the top of the screen — the floating
     nav (which is centered) doesn't horizontally overlap the
     left-anchored TOC, so they coexist cleanly.
     BODY_VERTICAL_PADDING_PX = the gap from the article body's top
     edge to the TOC's top edge (when TOC is anchored at body top),
     and the matching gap from the TOC's bottom to the body's bottom
     (when anchored at body bottom). Gives the TOC a bit of breathing
     room from the hero above + the next-reads section below. */
  var STICKY_OFFSET_PX = 48;
  var BODY_VERTICAL_PADDING_PX = 24;     // 1.5rem
  var DESKTOP_LEFT_PX = 24;              // 1.5rem
  var TOC_WIDTH_PX = 224;                // 14rem

  function isDesktop() {
    return window.matchMedia('(min-width: 1024px)').matches;
  }

  function positionToc(toc) {
    if (!isDesktop()) {
      // Mobile: CSS handles positioning. Just show the FAB if we're
      // currently within the article body region.
      var body = findArticleBody();
      if (!body) {
        toc.classList.remove('is-active');
        return;
      }
      var rect = body.getBoundingClientRect();
      var inBodyRegion = rect.top < window.innerHeight && rect.bottom > 0;
      if (inBodyRegion) toc.classList.add('is-active');
      else toc.classList.remove('is-active');
      // Clear any inline styles set by desktop positioning
      toc.style.position = '';
      toc.style.top = '';
      toc.style.left = '';
      return;
    }

    var body = findArticleBody();
    if (!body) {
      toc.classList.remove('is-active');
      return;
    }
    var rect = body.getBoundingClientRect();
    var docTop = window.pageYOffset || window.scrollY || 0;
    var bodyAbsTop = docTop + rect.top;
    var bodyAbsBottom = docTop + rect.bottom;
    var tocHeight = toc.offsetHeight;

    if (rect.top + BODY_VERTICAL_PADDING_PX > STICKY_OFFSET_PX) {
      // Body top still below sticky line — TOC at body's top + gap
      toc.style.position = 'absolute';
      toc.style.top = (bodyAbsTop + BODY_VERTICAL_PADDING_PX) + 'px';
      toc.style.left = DESKTOP_LEFT_PX + 'px';
    } else if (rect.bottom - tocHeight - BODY_VERTICAL_PADDING_PX < STICKY_OFFSET_PX) {
      // Body bottom approaching — pin TOC to body's bottom - gap
      toc.style.position = 'absolute';
      toc.style.top = (bodyAbsBottom - tocHeight - BODY_VERTICAL_PADDING_PX) + 'px';
      toc.style.left = DESKTOP_LEFT_PX + 'px';
    } else {
      // In body region — TOC sticks at viewport top
      toc.style.position = 'fixed';
      toc.style.top = STICKY_OFFSET_PX + 'px';
      toc.style.left = DESKTOP_LEFT_PX + 'px';
    }

    toc.classList.add('is-active');
  }

  /* Active-section indicator. Watch each h2 in the article body via
     IntersectionObserver with a tight rootMargin so only the heading
     near the top of the viewport registers as "active". When a
     heading hits the active zone, the matching TOC link gets
     [data-active] and CSS fills the dot. */
  function setupActiveIndicator(toc) {
    if (typeof IntersectionObserver === 'undefined') return;
    var headings = findHeadings();
    if (!headings.length) return;

    function getLinks() {
      var map = {};
      toc.querySelectorAll('.pi-article-toc__link').forEach(function(a) {
        var hash = a.getAttribute('href') || '';
        if (hash.charAt(0) === '#') {
          map[hash.slice(1)] = a;
        }
      });
      return map;
    }

    var visible = {};

    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (!e.target.id) return;
        if (e.isIntersecting) visible[e.target.id] = true;
        else delete visible[e.target.id];
      });

      // Find the topmost visible heading and mark it active
      var ordered = [];
      headings.forEach(function(h) {
        if (h.id && visible[h.id]) ordered.push(h);
      });

      var links = getLinks();
      var activeId = ordered.length ? ordered[0].id : null;

      // If nothing is currently in the active zone, find the LAST
      // heading whose top is above the active zone — that's the
      // section the reader is currently inside.
      if (!activeId) {
        var topZone = STICKY_OFFSET_PX + 80;
        var candidate = null;
        headings.forEach(function(h) {
          var rect = h.getBoundingClientRect();
          if (rect.top < topZone) candidate = h;
        });
        if (candidate) activeId = candidate.id;
      }

      Object.keys(links).forEach(function(id) {
        if (id === activeId) links[id].setAttribute('data-active', '');
        else links[id].removeAttribute('data-active');
      });
    }, { rootMargin: '-15% 0px -75% 0px', threshold: 0 });

    headings.forEach(function(h) { obs.observe(h); });
  }

  function init() {
    var toc = document.querySelector('[data-pi-article-toc]');
    if (!toc) return;

    autoGenerate(toc);

    /* Position on load + scroll + resize. requestAnimationFrame
       throttles to one update per frame for smooth performance even
       with the scroll-driven train behavior. */
    var ticking = false;
    function schedule() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(function() {
          positionToc(toc);
          ticking = false;
        });
      }
    }
    positionToc(toc);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });

    setupActiveIndicator(toc);

    /* FAB toggle (tablet/mobile). Click toggles [data-open]; clicking
       outside the toc closes; Escape key closes. */
    var fab = toc.querySelector('[data-pi-article-toc-fab]');
    if (fab) {
      fab.addEventListener('click', function(e) {
        e.stopPropagation();
        var open = toc.toggleAttribute('data-open');
        fab.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', function(e) {
        if (!toc.contains(e.target) && toc.hasAttribute('data-open')) {
          toc.removeAttribute('data-open');
          fab.setAttribute('aria-expanded', 'false');
        }
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && toc.hasAttribute('data-open')) {
          toc.removeAttribute('data-open');
          fab.setAttribute('aria-expanded', 'false');
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pi-begin-capture"] && !Shopify.designMode) return;
  try {
    
/* pi-begin-capture — validate, send the lead, go to checkout.
   The one rule that outranks everything else here: the buyer ALWAYS reaches
   checkout. The lead POST is best-effort and can fail in every way without
   costing us the sale. */
(function () {
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var LEAD_TIMEOUT_MS = 2500;

  function trim(v) { return (v || '').replace(/^\s+|\s+$/g, ''); }

  function setError(input, message) {
    var box = document.getElementById(input.getAttribute('aria-describedby'));
    if (box) { box.textContent = message || ''; }
    if (message) { input.setAttribute('aria-invalid', 'true'); }
    else { input.removeAttribute('aria-invalid'); }
  }

  /* Everything the page was tagged with, so the lead carries its source. */
  function readUtm() {
    var out = {};
    try {
      var q = new URLSearchParams(window.location.search);
      q.forEach(function (value, key) {
        var k = key.toLowerCase();
        if (k.indexOf('utm_') === 0 || k === 'gclid' || k === 'fbclid' || k === 'ref') {
          out[k] = value;
        }
      });
    } catch (e) {}
    return out;
  }

  /* Cart permalink: replaces the cart with exactly this one item and goes
     straight to checkout, with the contact fields pre-filled. The bracket
     characters are the documented permalink syntax and stay literal; only the
     values are encoded. */
  function checkoutUrl(variantId, first, last, email) {
    return '/cart/' + encodeURIComponent(variantId) + ':1'
      + '?checkout[email]=' + encodeURIComponent(email)
      + '&checkout[shipping_address][first_name]=' + encodeURIComponent(first)
      + '&checkout[shipping_address][last_name]=' + encodeURIComponent(last);
  }

  function init(form) {
    if (form.hasAttribute('data-pi-begin-ready')) { return; }
    form.setAttribute('data-pi-begin-ready', '');

    var button = form.querySelector('[data-pi-begin-submit]');
    var firstInput = form.querySelector('[name="first_name"]');
    var lastInput = form.querySelector('[name="last_name"]');
    var emailInput = form.querySelector('[name="email"]');
    var busy = false;

    /* Clear a field's error as soon as the buyer starts fixing it. */
    [firstInput, lastInput, emailInput].forEach(function (input) {
      input.addEventListener('input', function () {
        if (input.getAttribute('aria-invalid')) { setError(input, ''); }
      });
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (busy) { return; }

      var first = trim(firstInput.value);
      var last = trim(lastInput.value);
      var email = trim(emailInput.value);
      var bad = null;

      setError(firstInput, first ? '' : 'Enter your first name.');
      if (!first) { bad = bad || firstInput; }

      setError(lastInput, last ? '' : 'Enter your last name.');
      if (!last) { bad = bad || lastInput; }

      if (!email) { setError(emailInput, 'Enter your email.'); bad = bad || emailInput; }
      else if (!EMAIL.test(email)) { setError(emailInput, 'Enter a valid email address.'); bad = bad || emailInput; }
      else { setError(emailInput, ''); }

      if (bad) { bad.focus(); return; }

      busy = true;
      button.setAttribute('data-loading', '');
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-busy', 'true');

      var variantId = trim(form.getAttribute('data-variant-id'));
      var destination = checkoutUrl(variantId, first, last, email);
      var gone = false;

      function go() {
        if (gone) { return; }
        gone = true;
        window.location.href = destination;
      }

      var endpoint = trim(form.getAttribute('data-lead-endpoint'));
      if (!endpoint || !variantId) { go(); return; }

      var controller = null;
      try { controller = new AbortController(); } catch (e) {}

      var timer = window.setTimeout(function () {
        if (controller) { try { controller.abort(); } catch (e) {} }
        go();
      }, LEAD_TIMEOUT_MS);

      var options = {
        method: 'POST',
        mode: 'cors',
        keepalive: true,
        /* text/plain keeps this a "simple request" — no CORS preflight. */
        headers: { 'Content-Type': 'text/plain' },
        body: JSON.stringify({
          first_name: first,
          last_name: last,
          email: email,
          product: form.getAttribute('data-product-key') || '',
          consent: true,
          source: 'protocol',
          page: window.location.href,
          utm: readUtm()
        })
      };
      if (controller) { options.signal = controller.signal; }

      function done() { window.clearTimeout(timer); go(); }

      try {
        window.fetch(endpoint, options).then(done, done);
      } catch (e) {
        done();
      }
    });
  }

  function boot() {
    var forms = document.querySelectorAll('[data-pi-begin-form]');
    for (var i = 0; i < forms.length; i++) { init(forms[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  /* Theme editor re-render. */
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pi-benefit-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  function reduced() { return !!(RM && RM.matches); }

  function trackOf(panel) { return panel.querySelector('[data-pi-bt-track]'); }

  function updateArrows(panel) {
    var track = trackOf(panel);
    if (!track) return;
    var prev = panel.querySelector('.pi-benefit-tabs__arrow--prev');
    var next = panel.querySelector('.pi-benefit-tabs__arrow--next');
    if (!prev || !next) return;
    var stacked = getComputedStyle(track).flexDirection === 'column';
    var max = track.scrollWidth - track.clientWidth;
    if (stacked || max <= 1) {
      prev.hidden = true;
      next.hidden = true;
      return;
    }
    prev.hidden = false;
    next.hidden = false;
    prev.disabled = track.scrollLeft <= 1;
    next.disabled = track.scrollLeft >= max - 1;
  }

  function stepPx(track) {
    var cards = track.querySelectorAll('.pi-benefit-tabs__card');
    if (cards.length >= 2) return cards[1].offsetLeft - cards[0].offsetLeft;
    if (cards.length === 1) return cards[0].offsetWidth;
    return track.clientWidth;
  }

  function init(root) {
    if (!root || root.dataset.piBtInit === '1') return;
    root.dataset.piBtInit = '1';

    var tabs = root.querySelectorAll('.pi-benefit-tabs__tab');
    var panels = root.querySelectorAll('.pi-benefit-tabs__panel');
    var tablist = root.querySelector('[role="tablist"]');

    function activate(idx) {
      tabs.forEach(function (t, i) {
        var on = i === idx;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p, i) {
        p.classList.toggle('is-active', i === idx);
      });
      var active = panels[idx];
      if (active) {
        var track = trackOf(active);
        if (track) track.scrollLeft = 0;
        updateArrows(active);
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = parseInt(tab.dataset.index, 10);
        if (!isNaN(idx)) activate(idx);
      });
    });

    if (tablist) {
      tablist.addEventListener('keydown', function (e) {
        var k = e.key;
        if (k !== 'ArrowRight' && k !== 'ArrowLeft' && k !== 'Home' && k !== 'End') return;
        var current = root.querySelector('.pi-benefit-tabs__tab[aria-selected="true"]');
        var idx = Array.prototype.indexOf.call(tabs, current);
        var n = idx;
        if (k === 'ArrowRight') n = (idx + 1) % tabs.length;
        else if (k === 'ArrowLeft') n = (idx - 1 + tabs.length) % tabs.length;
        else if (k === 'Home') n = 0;
        else if (k === 'End') n = tabs.length - 1;
        e.preventDefault();
        activate(n);
        tabs[n].focus();
      });
    }

    panels.forEach(function (panel) {
      var track = trackOf(panel);
      if (!track) return;
      panel.querySelectorAll('.pi-benefit-tabs__arrow').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.dataset.dir, 10) || 1;
          track.scrollBy({ left: dir * stepPx(track), behavior: reduced() ? 'auto' : 'smooth' });
        });
      });
      track.addEventListener('scroll', function () { updateArrows(panel); }, { passive: true });
    });

    function refresh() {
      panels.forEach(function (p) {
        if (p.classList.contains('is-active')) updateArrows(p);
      });
    }
    window.addEventListener('resize', refresh, { passive: true });

    var first = root.querySelector('.pi-benefit-tabs__panel.is-active');
    if (first) updateArrows(first);
  }

  function boot() {
    document.querySelectorAll('[data-pi-benefit-tabs]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('[data-pi-benefit-tabs]');
    if (sec) init(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pi-blog-accordion"] && !Shopify.designMode) return;
  try {
    
/* Show-more reveal + cross-page AJAX load.

   Stage 1: each click reveals up to `batch` hidden entries already in
   the DOM (first 50 articles). Once those are exhausted, Stage 2 kicks
   in: if the button has data-next-page-url, fetch that ?page=N URL,
   parse the response, append the next 50 article entries (marked
   data-hidden so Stage 1 batching continues), and update the button's
   data-next-page-url to point to the page after that.

   This is how the section supports blogs with hundreds of articles —
   server-side paginate generates each page's HTML; JS stitches pages
   together transparently behind a single "Show more" button. */
(function() {
  if (window.__piBlogAccordionWired) return;
  window.__piBlogAccordionWired = true;

  function revealBatch(section) {
    const batch = parseInt(section.getAttribute('data-batch'), 10) || 8;
    const hidden = section.querySelectorAll('.pi-blog-accordion__entry[data-hidden]');
    let shown = 0;
    for (let i = 0; i < hidden.length && shown < batch; i++) {
      hidden[i].removeAttribute('data-hidden');
      shown++;
    }
    return shown;
  }

  async function loadNextPage(section, btn, nextUrl) {
    btn.setAttribute('data-loading', '');
    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error('Fetch failed: ' + response.status);
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const sourceSection = doc.querySelector('[data-pi-blog-accordion]');
      if (!sourceSection) throw new Error('No matching section in response');
      const newEntries = sourceSection.querySelectorAll('.pi-blog-accordion__entry');
      if (newEntries.length === 0) throw new Error('No entries in response');
      // Find the list container in current DOM (parent of existing entries)
      const existingEntry = section.querySelector('.pi-blog-accordion__entry');
      const container = existingEntry ? existingEntry.parentNode : null;
      if (!container) throw new Error('No entry container found');
      // Append new entries — all marked data-hidden so Stage 1 batching
      // reveals them on subsequent clicks.
      newEntries.forEach(function(entry) {
        entry.setAttribute('data-hidden', '');
        container.appendChild(entry);
      });
      // Update the next-page URL from the response (or clear it if this
      // was the last page).
      const sourceBtn = sourceSection.querySelector('[data-pi-blog-more]');
      const newNextUrl = sourceBtn ? sourceBtn.getAttribute('data-next-page-url') : '';
      if (newNextUrl) {
        btn.setAttribute('data-next-page-url', newNextUrl);
      } else {
        btn.removeAttribute('data-next-page-url');
      }
      // Reveal one batch of the newly-appended entries immediately so
      // the click felt like it did something.
      revealBatch(section);
    } catch (err) {
      console.warn('pi-blog-accordion: load next page failed', err);
    } finally {
      btn.removeAttribute('data-loading');
    }
  }

  function handleMoreClick(section) {
    const btn = section.querySelector('[data-pi-blog-more]');
    if (!btn) return;
    if (btn.hasAttribute('data-loading')) return; // mid-fetch — ignore
    // Stage 1 — reveal hidden in-DOM entries
    const revealed = revealBatch(section);
    const remaining = section.querySelectorAll('.pi-blog-accordion__entry[data-hidden]').length;
    if (remaining > 0) return; // still have hidden — leave button visible
    // Stage 2 — fetch next page if available
    const nextUrl = btn.getAttribute('data-next-page-url');
    if (nextUrl) {
      loadNextPage(section, btn, nextUrl);
    } else if (revealed === 0) {
      // Truly nothing left to reveal AND no next page — exhaust button
      btn.setAttribute('data-exhausted', '');
    }
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-pi-blog-more]');
    if (!btn) return;
    e.preventDefault();
    const section = btn.closest('[data-pi-blog-accordion]');
    if (section) handleMoreClick(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pi-blog-card-gallery"] && !Shopify.designMode) return;
  try {
    
/* Shared gallery reveal + cross-page AJAX load — handles both
   pi-blog-card-gallery and pi-event-card-gallery (any section with
   data-pi-gallery + data-batch on the root + a [data-pi-gallery-sentinel]
   near the bottom).

   Two trigger paths into the same handler:
     - Click on [data-pi-gallery-more] (manual fallback / a11y)
     - IntersectionObserver on the sentinel (auto-reveal on scroll)

   Stage 1: reveal a batch of [data-hidden] items already in the DOM
   (Liquid renders the first 50 articles, marking items beyond `initial`
   with data-hidden).

   Stage 2: when no [data-hidden] items remain AND the button carries a
   data-next-page-url, AJAX-fetch that ?page=N URL, parse, and append
   the next 50 articles (all marked data-hidden so the observer keeps
   firing). Update data-next-page-url from the response so subsequent
   exhaustion fetches the page after that.

   Single-attach guard via window.__piGalleryWired. */
(function() {
  if (window.__piGalleryWired) return;
  window.__piGalleryWired = true;

  function revealBatch(section) {
    var batch = parseInt(section.getAttribute('data-batch'), 10) || 6;
    var hidden = section.querySelectorAll('[data-hidden]');
    var shown = 0;
    for (var i = 0; i < hidden.length && shown < batch; i++) {
      hidden[i].removeAttribute('data-hidden');
      shown++;
    }
    return shown;
  }

  function findItemSelector(section) {
    // Each gallery type uses its own item class. Find a sample item to
    // determine the selector, so this code works for both pi-blog-card-
    // gallery and pi-event-card-gallery without hardcoding.
    var sample = section.querySelector('[data-hidden], li[class*="__item"]');
    if (!sample) return null;
    // Use the first class that ends with __item
    var classes = sample.className.split(' ');
    for (var i = 0; i < classes.length; i++) {
      if (classes[i].indexOf('__item') !== -1) return '.' + classes[i];
    }
    return null;
  }

  function loadNextPage(section, btn, nextUrl) {
    btn.setAttribute('data-loading', '');
    return fetch(nextUrl).then(function(response) {
      if (!response.ok) throw new Error('Fetch failed: ' + response.status);
      return response.text();
    }).then(function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var sourceSection = doc.querySelector('[data-pi-gallery]');
      if (!sourceSection) throw new Error('No matching gallery in response');
      var itemSel = findItemSelector(section);
      if (!itemSel) throw new Error('No item selector');
      var newItems = sourceSection.querySelectorAll(itemSel);
      if (newItems.length === 0) throw new Error('No items in response');
      // Find list container in current DOM
      var existing = section.querySelector(itemSel);
      var container = existing ? existing.parentNode : null;
      if (!container) throw new Error('No item container found');
      newItems.forEach(function(item) {
        item.setAttribute('data-hidden', '');
        container.appendChild(item);
      });
      // Update data-next-page-url from response
      var sourceBtn = sourceSection.querySelector('[data-pi-gallery-more]');
      var newNextUrl = sourceBtn ? sourceBtn.getAttribute('data-next-page-url') : '';
      if (newNextUrl) {
        btn.setAttribute('data-next-page-url', newNextUrl);
      } else {
        btn.removeAttribute('data-next-page-url');
      }
      // Reveal a batch of the newly-appended items immediately
      revealBatch(section);
    }).catch(function(err) {
      console.warn('pi-gallery: load next page failed', err);
    }).then(function() {
      btn.removeAttribute('data-loading');
    });
  }

  function trigger(section) {
    var btn = section.querySelector('[data-pi-gallery-more]');
    if (btn && btn.hasAttribute('data-loading')) return;
    var revealed = revealBatch(section);
    var remaining = section.querySelectorAll('[data-hidden]').length;
    if (remaining > 0) return;
    // Exhausted in-DOM — try to load next paginate page
    var nextUrl = btn ? btn.getAttribute('data-next-page-url') : '';
    if (nextUrl) {
      loadNextPage(section, btn, nextUrl);
      return;
    }
    // Truly exhausted
    if (btn) btn.setAttribute('data-exhausted', '');
    var sentinel = section.querySelector('[data-pi-gallery-sentinel]');
    if (sentinel && sentinel.__piObs) {
      sentinel.__piObs.disconnect();
      sentinel.__piObs = null;
    }
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-pi-gallery-more]');
    if (!btn) return;
    e.preventDefault();
    var section = btn.closest('[data-pi-gallery]');
    if (section) trigger(section);
  });

  function initAutoReveal() {
    if (typeof IntersectionObserver === 'undefined') return;
    var sections = document.querySelectorAll('[data-pi-gallery]');
    for (var i = 0; i < sections.length; i++) {
      (function(section) {
        var sentinel = section.querySelector('[data-pi-gallery-sentinel]');
        if (!sentinel || sentinel.__piObs) return;
        var obs = new IntersectionObserver(function(entries) {
          for (var j = 0; j < entries.length; j++) {
            if (entries[j].isIntersecting) trigger(section);
          }
        }, { rootMargin: '0px 0px 480px 0px', threshold: 0 });
        obs.observe(sentinel);
        sentinel.__piObs = obs;
      })(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutoReveal);
  } else {
    initAutoReveal();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pi-event-card-gallery"] && !Shopify.designMode) return;
  try {
    
/* Shared gallery reveal — handles both pi-blog-card-gallery and
   pi-event-card-gallery (any section with data-pi-gallery + data-batch
   on the section root + a [data-pi-gallery-sentinel] near the bottom).
   Two trigger paths into the same reveal() function:
     - Click on [data-pi-gallery-more] (manual fallback / a11y)
     - IntersectionObserver on the sentinel (auto-reveal on scroll)
   Single-attach guard via window.__piGalleryWired so duplicate JS
   blocks (one per gallery section type) don't double-bind handlers. */
(function() {
  if (window.__piGalleryWired) return;
  window.__piGalleryWired = true;

  function reveal(section) {
    var btn = section.querySelector('[data-pi-gallery-more]');
    var batch = parseInt(section.getAttribute('data-batch'), 10) || 6;
    var hidden = section.querySelectorAll('[data-hidden]');
    var shown = 0;
    for (var i = 0; i < hidden.length && shown < batch; i++) {
      hidden[i].removeAttribute('data-hidden');
      shown++;
    }
    if (section.querySelectorAll('[data-hidden]').length === 0) {
      if (btn) btn.setAttribute('data-exhausted', '');
      var sentinel = section.querySelector('[data-pi-gallery-sentinel]');
      if (sentinel && sentinel.__piObs) {
        sentinel.__piObs.disconnect();
        sentinel.__piObs = null;
      }
    }
  }

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-pi-gallery-more]');
    if (!btn) return;
    e.preventDefault();
    var section = btn.closest('[data-pi-gallery]');
    if (section) reveal(section);
  });

  function initAutoReveal() {
    if (typeof IntersectionObserver === 'undefined') return;
    var sections = document.querySelectorAll('[data-pi-gallery]');
    for (var i = 0; i < sections.length; i++) {
      (function(section) {
        var sentinel = section.querySelector('[data-pi-gallery-sentinel]');
        if (!sentinel || sentinel.__piObs) return;
        var obs = new IntersectionObserver(function(entries) {
          for (var j = 0; j < entries.length; j++) {
            if (entries[j].isIntersecting) reveal(section);
          }
        }, { rootMargin: '0px 0px 480px 0px', threshold: 0 });
        obs.observe(sentinel);
        sentinel.__piObs = obs;
      })(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutoReveal);
  } else {
    initAutoReveal();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pi-faq-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.piFaqTabsInit === '1') return;
    root.dataset.piFaqTabsInit = '1';

    var tabs = root.querySelectorAll('.pi-faq-tabs__cat');
    var groups = root.querySelectorAll('.pi-faq-tabs__group');
    var tablist = root.querySelector('[role="tablist"]');
    if (!tabs.length) return;

    function activate(idx) {
      tabs.forEach(function (t, i) {
        var on = i === idx;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        t.classList.toggle('is-active', on);
      });
      groups.forEach(function (g, i) {
        var on = i === idx;
        g.hidden = !on;
        g.classList.toggle('is-active', on);
        if (on) {
          g.querySelectorAll('details[open]').forEach(function (d) { d.open = false; });
        }
      });
      // Keep the active category centered in the horizontal strip (never scrolls the page).
      var active = tabs[idx];
      if (active && tablist && tablist.scrollWidth > tablist.clientWidth) {
        var lr = tablist.getBoundingClientRect();
        var tr = active.getBoundingClientRect();
        tablist.scrollLeft += (tr.left + tr.width / 2) - (lr.left + lr.width / 2);
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = parseInt(tab.dataset.index, 10);
        if (!isNaN(idx)) activate(idx);
      });
    });

    if (tablist) {
      tablist.addEventListener('keydown', function (e) {
        var k = e.key;
        var step = (k === 'ArrowRight' || k === 'ArrowDown') ? 1
                 : (k === 'ArrowLeft' || k === 'ArrowUp') ? -1 : 0;
        if (!step && k !== 'Home' && k !== 'End') return;
        var current = root.querySelector('.pi-faq-tabs__cat[aria-selected="true"]');
        var idx = Array.prototype.indexOf.call(tabs, current);
        var n = idx < 0 ? 0 : idx;
        if (k === 'Home') n = 0;
        else if (k === 'End') n = tabs.length - 1;
        else n = (idx + step + tabs.length) % tabs.length;
        e.preventDefault();
        activate(n);
        tabs[n].focus();
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-pi-faq-tabs]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('[data-pi-faq-tabs]');
    if (sec) init(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pi-hero-motion"] && !Shopify.designMode) return;
  try {
    
(function () {
  function attachVideo(root) {
    var video = root.querySelector('[data-pi-hero-motion-video]');
    if (!video) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    if (reduce || mobile) return;

    var sources = video.querySelectorAll('source[data-src]');
    if (!sources.length) return;

    function attach() {
      sources.forEach(function (src) {
        src.setAttribute('src', src.getAttribute('data-src'));
      });
      video.load();
      var playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.1 });
        observer.observe(video);
      }
    }

    // Attach the source only after first paint so poster/photo bytes win the
    // LCP race — never the video (SPEC-hero-motion.md §8/GX3).
    if (window.requestAnimationFrame) {
      requestAnimationFrame(function () {
        requestAnimationFrame(attach);
      });
    } else {
      window.addEventListener('load', attach, { once: true });
    }
  }

  function init(root) {
    if (!root || root.dataset.piHeroMotionInit === '1') return;
    root.dataset.piHeroMotionInit = '1';
    attachVideo(root);
  }

  function boot() {
    document.querySelectorAll('[data-pi-hero-motion]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('[data-pi-hero-motion]');
    if (sec) init(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pi-included"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.piIncInit === '1') return;
    root.dataset.piIncInit = '1';

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;

    root.classList.add('pi-included--anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          root.classList.add('is-in');
          io.disconnect();
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });
    io.observe(root);
  }

  function boot() {
    document.querySelectorAll('[data-pi-included]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('[data-pi-included]');
    if (sec) init(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pi-page-toc"] && !Shopify.designMode) return;
  try {
    
(function() {
  if (window.__piPageTocWired) return;
  window.__piPageTocWired = true;

  /* Mirror pi-article-toc's STICKY_OFFSET / BODY_VERTICAL_PADDING / DESKTOP_LEFT
     so the two patterns sit at exactly the same x/y in their respective
     templates. */
  var STICKY_OFFSET_PX = 48;
  var BODY_VERTICAL_PADDING_PX = 24;
  var DESKTOP_LEFT_PX = 24;

  function isDesktop() {
    return window.matchMedia('(min-width: 1024px)').matches;
  }

  function getMode(toc) {
    return toc.getAttribute('data-pi-page-toc-mode') || 'single';
  }

  function findTarget(toc) {
    var sel = toc.getAttribute('data-pi-page-toc-target') || '';
    if (!sel) return null;
    return document.querySelector(sel);
  }

  /* Auto-body-region mode: walk siblings forward from the TOC's outer
     .shopify-section wrapper, collecting every body section until we
     hit the footer. Each body section gets `.pi-page-toc-shifted` on
     its inner pi-* element so the existing CSS rule applies the
     asymmetric padding to that section's .pi-container. */
  function findBodySections(toc) {
    var wrapper = toc.closest && toc.closest('.shopify-section');
    if (!wrapper) return [];
    var inners = [];
    var sib = wrapper.nextElementSibling;
    while (sib) {
      if (!sib.classList || !sib.classList.contains('shopify-section')) {
        sib = sib.nextElementSibling;
        continue;
      }
      var id = sib.id || '';
      var cls = sib.className || '';
      if (id.indexOf('footer') !== -1) break;
      if (cls.indexOf('pi-footer-wrapper') !== -1) break;
      if (cls.indexOf('pi-footer-section') !== -1) break;
      // The pi-* sections have an inner element with .pi-section
      // (e.g. <section class="pi-scope pi-rich-text pi-section pi-section--lg">).
      // Tag that element so the .pi-page-toc-shifted > .pi-container CSS
      // rule matches its direct .pi-container child.
      var inner = sib.querySelector('.pi-section') || sib.firstElementChild;
      if (inner) inners.push(inner);
      sib = sib.nextElementSibling;
    }
    return inners;
  }

  function slugify(text) {
    return (text || '').toLowerCase()
      .replace(/[^\w\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .slice(0, 80);
  }

  /* Find every h2 across the body region. Auto-assign ids by slugifying
     the text content (mirrors pi-article-toc's behavior for article h2s). */
  function findBodyHeadings(sections) {
    var h2s = [];
    sections.forEach(function(sec) {
      var found = sec.querySelectorAll('h2');
      for (var i = 0; i < found.length; i++) {
        var h2 = found[i];
        if (!h2.id) {
          var slug = slugify(h2.textContent);
          if (slug) h2.id = slug;
        }
        if (h2.id) h2s.push(h2);
      }
    });
    return h2s;
  }

  /* Eyebrow mode: one TOC entry PER body section, labeled by that
     section's eyebrow element ([class$="__eyebrow"]). The anchor target
     is the section's first h2 (auto-id'd if missing); if there's no h2,
     fall back to assigning an id to the eyebrow element itself.

     Sections without an eyebrow are skipped — eyebrow-mode is opt-in
     per page, used when the page's eyebrows are a more curated TOC
     vocabulary than the full h2 list (e.g. methodology page, where
     eyebrows read "The thesis / The problem / The landscape ..." but
     h2 text is paragraph-length section titles). */
  function findSectionEyebrows(sections) {
    var items = [];
    sections.forEach(function(sec) {
      var eb = sec.querySelector('[class$="__eyebrow"]');
      if (!eb) return;
      var label = (eb.textContent || '').trim();
      if (!label) return;
      // Anchor target: prefer first h2 in this section. If no h2,
      // assign an id to the section's inner pi-section element itself.
      var anchorEl = sec.querySelector('h2');
      if (anchorEl) {
        if (!anchorEl.id) {
          var slug = slugify(anchorEl.textContent);
          if (slug) anchorEl.id = slug;
        }
      } else {
        anchorEl = sec;
        if (!anchorEl.id) anchorEl.id = 'pi-toc-' + slugify(label);
      }
      if (!anchorEl.id) return;
      items.push({ id: anchorEl.id, label: label, el: anchorEl });
    });
    return items;
  }

  /* Single source of truth for "what the TOC lists" + "what the
     positioning machinery treats as the body region". Returns:
       items   — the elements that become TOC entries (cards or h2s)
       bounds  — { top, bottom } of the region, computed live so the
                 caller can re-evaluate per scroll tick
       cleanup — any per-render side effects (currently none)
  */
  function getTocData(toc) {
    var mode = getMode(toc);
    if (mode === 'auto-body-region') {
      var sections = findBodySections(toc);
      // Mark each so CSS shifts the inner .pi-container right.
      sections.forEach(function(sec) { sec.classList.add('pi-page-toc-shifted'); });
      var preferEyebrow = toc.getAttribute('data-pi-page-toc-prefer-eyebrow') === 'true';
      var items = preferEyebrow ? findSectionEyebrows(sections) : findBodyHeadings(sections);
      return {
        mode: mode,
        preferEyebrow: preferEyebrow,
        items: items,
        getBounds: function() {
          if (!sections.length) return null;
          var first = sections[0].getBoundingClientRect();
          var last  = sections[sections.length - 1].getBoundingClientRect();
          return { top: first.top, bottom: last.bottom };
        }
      };
    }
    // Single-container mode (existing behavior).
    var target = findTarget(toc);
    var sel = toc.getAttribute('data-pi-page-toc-cards') || '';
    var cards = (target && sel) ? Array.prototype.slice.call(target.querySelectorAll(sel)) : [];
    return {
      mode: mode,
      items: cards.filter(function(c) { return c.id; }),
      getBounds: function() {
        if (!target) return null;
        var r = target.getBoundingClientRect();
        return { top: r.top, bottom: r.bottom };
      },
      target: target
    };
  }

  function findCards(toc) {
    // Back-compat shim — still used by callers below. Returns the items
    // for whichever mode is active.
    return getTocData(toc).items;
  }

  /* Populate the TOC list. In single mode, each card's id becomes the
     anchor and `title_selector`'s text becomes the label. In
     auto-body-region mode, each h2's id becomes the anchor and the h2
     text becomes the label (h2 IS the title element). Items without
     ids are skipped. */
  function autoGenerate(toc) {
    var list = toc.querySelector('[data-pi-page-toc-list]');
    if (!list) return 0;
    var data = getTocData(toc);
    var items = data.items;
    var titleSel = toc.getAttribute('data-pi-page-toc-title-sel') || '';
    var isBodyRegion = data.mode === 'auto-body-region';
    var added = 0;

    items.forEach(function(item) {
      // Eyebrow-mode items are {id, label, el} objects; everything else
      // is the raw DOM element.
      var isEyebrowItem = item && typeof item === 'object' && 'label' in item && 'el' in item;
      var id = item.id;
      if (!id) return;
      var text;
      if (isEyebrowItem) {
        text = item.label;
      } else {
        // Body-region: item IS the h2 (use its text directly).
        // Single mode: item is a card, look inside via titleSel.
        var titleEl;
        if (isBodyRegion) {
          titleEl = item;
        } else {
          titleEl = titleSel ? item.querySelector(titleSel) : item;
        }
        text = (titleEl ? titleEl.textContent : item.textContent || '').trim();
      }
      if (!text) return;

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.className = 'pi-page-toc__link';

      var dot = document.createElement('span');
      dot.className = 'pi-page-toc__dot';
      dot.setAttribute('aria-hidden', 'true');

      var span = document.createElement('span');
      span.className = 'pi-page-toc__text';
      span.textContent = text;

      a.appendChild(dot);
      a.appendChild(span);
      li.appendChild(a);
      list.appendChild(li);
      added++;
    });

    if (added === 0) toc.style.display = 'none';
    return added;
  }

  function positionToc(toc) {
    var data = getTocData(toc);
    var bounds = data.getBounds && data.getBounds();
    if (!bounds) {
      toc.classList.remove('is-active');
      return;
    }

    if (!isDesktop()) {
      var inRegion = bounds.top < window.innerHeight && bounds.bottom > 0;
      if (inRegion) toc.classList.add('is-active');
      else toc.classList.remove('is-active');
      toc.style.position = '';
      toc.style.top = '';
      toc.style.left = '';
      return;
    }

    var rect = { top: bounds.top, bottom: bounds.bottom };
    var docTop = window.pageYOffset || window.scrollY || 0;
    var bodyAbsTop = docTop + rect.top;
    var bodyAbsBottom = docTop + rect.bottom;
    var tocHeight = toc.offsetHeight;

    if (rect.top + BODY_VERTICAL_PADDING_PX > STICKY_OFFSET_PX) {
      toc.style.position = 'absolute';
      toc.style.top = (bodyAbsTop + BODY_VERTICAL_PADDING_PX) + 'px';
      toc.style.left = DESKTOP_LEFT_PX + 'px';
    } else if (rect.bottom - tocHeight - BODY_VERTICAL_PADDING_PX < STICKY_OFFSET_PX) {
      toc.style.position = 'absolute';
      toc.style.top = (bodyAbsBottom - tocHeight - BODY_VERTICAL_PADDING_PX) + 'px';
      toc.style.left = DESKTOP_LEFT_PX + 'px';
    } else {
      toc.style.position = 'fixed';
      toc.style.top = STICKY_OFFSET_PX + 'px';
      toc.style.left = DESKTOP_LEFT_PX + 'px';
    }

    toc.classList.add('is-active');
  }

  /* Active-section indicator. Watch each card via IntersectionObserver
     with a tight rootMargin so only cards near the top of the viewport
     register as "active". When a card enters the active zone, the
     matching TOC link gets [data-active] and CSS fills the dot. */
  function setupActiveIndicator(toc) {
    if (typeof IntersectionObserver === 'undefined') return;
    // findCards returns DOM elements (h2s, accordion cards, etc) OR eyebrow-mode
    // items in {id, label, el} shape. Normalize to the DOM element so observe()
    // and getBoundingClientRect() work uniformly.
    var cards = findCards(toc).map(function(c) {
      return (c && c.el && c.el.nodeType === 1) ? c.el : c;
    });
    if (!cards.length) return;

    function getLinks() {
      var map = {};
      toc.querySelectorAll('.pi-page-toc__link').forEach(function(a) {
        var hash = a.getAttribute('href') || '';
        if (hash.charAt(0) === '#') map[hash.slice(1)] = a;
      });
      return map;
    }

    var visible = {};
    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (!e.target.id) return;
        if (e.isIntersecting) visible[e.target.id] = true;
        else delete visible[e.target.id];
      });

      var ordered = [];
      cards.forEach(function(c) { if (c.id && visible[c.id]) ordered.push(c); });

      var links = getLinks();
      var activeId = ordered.length ? ordered[0].id : null;

      // Fallback: last card whose top is above the active zone
      if (!activeId) {
        var topZone = STICKY_OFFSET_PX + 80;
        var candidate = null;
        cards.forEach(function(c) {
          var rect = c.getBoundingClientRect();
          if (rect.top < topZone) candidate = c;
        });
        if (candidate) activeId = candidate.id;
      }

      Object.keys(links).forEach(function(id) {
        if (id === activeId) links[id].setAttribute('data-active', '');
        else links[id].removeAttribute('data-active');
      });
    }, { rootMargin: '-15% 0px -75% 0px', threshold: 0 });

    cards.forEach(function(c) { if (c.id) obs.observe(c); });
  }

  function init() {
    document.querySelectorAll('[data-pi-page-toc]').forEach(function(toc) {
      var added = autoGenerate(toc);
      if (added === 0) return;

      // Single-mode: tag the target container so CSS shifts its inner
      // .pi-container right. Body-region mode already tagged each body
      // section inside getTocData() during the first call (cards or h2
      // discovery). Calling again here on `findTarget` for that mode
      // would be a no-op (target_container default isn't on the page),
      // so we gate this on mode.
      if (getMode(toc) === 'single') {
        var target = findTarget(toc);
        if (target) target.classList.add('pi-page-toc-shifted');
      }

      var ticking = false;
      function schedule() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(function() {
            positionToc(toc);
            ticking = false;
          });
        }
      }
      positionToc(toc);
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });

      setupActiveIndicator(toc);

      var fab = toc.querySelector('[data-pi-page-toc-fab]');
      if (fab) {
        fab.addEventListener('click', function(e) {
          e.stopPropagation();
          var open = toc.toggleAttribute('data-open');
          fab.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        document.addEventListener('click', function(e) {
          if (!toc.contains(e.target) && toc.hasAttribute('data-open')) {
            toc.removeAttribute('data-open');
            fab.setAttribute('aria-expanded', 'false');
          }
        });
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && toc.hasAttribute('data-open')) {
            toc.removeAttribute('data-open');
            fab.setAttribute('aria-expanded', 'false');
          }
        });
        // Close popup on link click
        toc.addEventListener('click', function(e) {
          if (e.target.closest('.pi-page-toc__link') && toc.hasAttribute('data-open')) {
            toc.removeAttribute('data-open');
            fab.setAttribute('aria-expanded', 'false');
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pi-pdp-sticky-cart"] && !Shopify.designMode) return;
  try {
    
/* Reveal the floating sticky cart once the user scrolls past the main
   product info column on pi-product-detail. IntersectionObserver
   watches [data-pi-pdp-info]. When the column's bottom crosses above
   the viewport top, show the pill. When the column is back in view,
   hide it. Single-attach guard via window.__piPdpStickyCartWired. */
(function() {
  if (window.__piPdpStickyCartWired) return;
  window.__piPdpStickyCartWired = true;

  function init() {
    if (typeof IntersectionObserver === 'undefined') return;
    var sticky = document.querySelector('[data-pi-pdp-sticky-cart]');
    if (!sticky) return;
    var trigger = document.querySelector('[data-pi-pdp-info]');
    if (!trigger) return;

    function setShown(shown) {
      if (shown) {
        sticky.setAttribute('data-show', '');
        sticky.setAttribute('aria-hidden', 'false');
      } else {
        sticky.removeAttribute('data-show');
        sticky.setAttribute('aria-hidden', 'true');
      }
    }

    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var pastTop = entry.boundingClientRect.bottom < 0;
        setShown(pastTop);
      });
    }, { threshold: 0 });

    obs.observe(trigger);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pi-plan-path"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.piPpInit === '1') return;
    root.dataset.piPpInit = '1';

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // No IntersectionObserver or reduced motion: leave the content fully
    // visible (never arm the hidden initial state).
    if (reduce || !('IntersectionObserver' in window)) return;

    root.classList.add('pi-plan-path--anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          root.classList.add('is-in');
          io.disconnect();
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });
    io.observe(root);
  }

  function boot() {
    document.querySelectorAll('[data-pi-plan-path]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('[data-pi-plan-path]');
    if (sec) init(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pi-plan-steps"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal(root) {
    root.classList.add('is-revealed');
  }

  function init(root) {
    if (!root || root.dataset.piPlanStepsInit === '1') return;
    root.dataset.piPlanStepsInit = '1';

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      reveal(root);
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          reveal(root);
          obs.disconnect();
          break;
        }
      }
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });

    io.observe(root);
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-pi-plan-steps]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('[data-pi-plan-steps]');
    if (sec) init(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pi-product-detail"] && !Shopify.designMode) return;
  try {
    
// Loox-rating link scroll-to-reviews.
// The Loox app block has a different section id per template
// (loox_reviews_loox_dynamic_section_jCA9mV on the Superpower PDP,
// ..._6Xakbm on the CSDA PDP), so the link uses a stub anchor
// href="#loox_reviews" and this handler finds whichever Loox-rendered
// container exists at click time. Falls through to default anchor
// behavior if no Loox element is found (so the URL fragment still
// updates and the page doesn't break).
document.addEventListener('click', function (e) {
  var trigger = e.target.closest('[data-pi-scroll-loox]');
  if (!trigger) return;
  // Loox renders its widget as <div id="looxReviews"> inside an app
  // block (shopify-block-...). Target by Loox's standard widget id
  // first, fall back to any id containing 'loox_reviews', then to its
  // default class. Verified at runtime on the CSDA PDP — actual ids
  // observed: 'shopify-block-...loox_reviews_loox_dynamic_section_*'
  // and 'looxReviews'.
  var loox =
    document.getElementById('looxReviews') ||
    document.querySelector('[id*="loox_reviews"]') ||
    document.querySelector('.loox-reviews-default, [class*="loox-reviews"]');
  if (!loox) return; // fall back to native anchor scroll
  e.preventDefault();
  loox.scrollIntoView({ behavior: 'smooth', block: 'start' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pi-tabbed-slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.piTsInit === '1') return;
    root.dataset.piTsInit = '1';

    var tabs   = root.querySelectorAll('.pi-tabbed-slideshow__tab');
    var panels = root.querySelectorAll('.pi-tabbed-slideshow__panel');
    var accords = root.querySelectorAll('.pi-tabbed-slideshow__accord');
    var tablist = root.querySelector('[role="tablist"]');

    function activate(idx) {
      tabs.forEach(function (t, i) {
        var on = i === idx;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p, i) {
        p.classList.toggle('is-active', i === idx);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = parseInt(tab.dataset.index, 10);
        if (!isNaN(idx)) activate(idx);
      });
    });

    if (tablist) {
      tablist.addEventListener('keydown', function (e) {
        var key = e.key;
        if (key !== 'ArrowRight' && key !== 'ArrowLeft' && key !== 'Home' && key !== 'End') return;
        var activeTab = root.querySelector('.pi-tabbed-slideshow__tab[aria-selected="true"]');
        var idx = Array.prototype.indexOf.call(tabs, activeTab);
        var newIdx = idx;
        if (key === 'ArrowRight') newIdx = (idx + 1) % tabs.length;
        else if (key === 'ArrowLeft') newIdx = (idx - 1 + tabs.length) % tabs.length;
        else if (key === 'Home') newIdx = 0;
        else if (key === 'End') newIdx = tabs.length - 1;
        e.preventDefault();
        activate(newIdx);
        tabs[newIdx].focus();
      });
    }

    accords.forEach(function (accord) {
      accord.addEventListener('click', function () {
        var expanded = accord.getAttribute('aria-expanded') === 'true';
        accord.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-pi-tabbed-slideshow]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('[data-pi-tabbed-slideshow]');
    if (sec) init(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pi-ugc-wall"] && !Shopify.designMode) return;
  try {
    
(function () {
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var SPEED = { slow: 35, normal: 55, fast: 90 }; // px/sec — one calm horizontal glide per row

  function rootFontPx() {
    return parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
  }
  function pxVar(el, name) {
    var raw = (getComputedStyle(el).getPropertyValue(name) || '').trim();
    if (!raw) return 0;
    var n = parseFloat(raw);
    if (isNaN(n)) return 0;
    return raw.indexOf('rem') > -1 ? n * rootFontPx() : n;
  }

  // A tile is a video if it carries the vertical/horizontal class (vs a --card review tile).
  function isVideoTile(node) {
    var c = node.className || '';
    return c.indexOf('--vertical') > -1 || c.indexOf('--horizontal') > -1;
  }

  function capFor(base) {
    var w = window.innerWidth || 1280;
    if (w <= 600) return 2;
    if (w <= 1024) return Math.min(base, 4);
    return Math.max(2, base);
  }

  // Assemble one COLUMN of n tiles, guaranteeing a video: a 1-tile column is always a
  // full-height video; multi-tile columns pair a video with card(s) (the QOVES stack).
  // The video/card queues cycle + repeat as the marquee needs more.
  function makeCol(n, idx, nextV, nextC) {
    var col = document.createElement('div');
    col.className = 'pi-ugc-wall__col';
    var tiles;
    if (n <= 1) tiles = [nextV()];
    else if (n === 2) tiles = (idx % 2) ? [nextV(), nextC()] : [nextC(), nextV()];
    else tiles = (idx % 2) ? [nextC(), nextV(), nextC()] : [nextV(), nextC(), nextV()];
    tiles.forEach(function (t) { col.appendChild(t); });
    return col;
  }

  function throttle(fn, wait) {
    var last = 0, timer;
    return function () {
      var now = Date.now(), remaining = wait - (now - last);
      if (remaining <= 0) { last = now; fn(); }
      else { clearTimeout(timer); timer = setTimeout(function () { last = Date.now(); fn(); }, remaining); }
    };
  }

  // ---- Floating pop-out player (Kenneth's "Most"-style request) ------------
  // ONE player per page, cloned from the <template> into <body> on first open.
  // Pinned bottom-left (bottom-centre on phones), position:fixed, so the wall
  // and the page keep scrolling behind it while a clip plays. Source is attached
  // only on open and detached on close — no tile preloads a video.
  var PLR = null, PVID = null, PFILL = null, POPENER = null, escWired = false;

  function setPAria(act, label) {
    var b = PLR && PLR.querySelector('[data-act="' + act + '"]');
    if (b) b.setAttribute('aria-label', label);
  }
  function pTogglePlay() {
    if (!PVID) return;
    if (PVID.paused) { var p = PVID.play(); if (p && p.catch) p.catch(function () {}); }
    else { PVID.pause(); }
  }
  function pToggleMute() {
    if (!PVID) return;
    PVID.muted = !PVID.muted;
    PLR.classList.toggle('is-unmuted', !PVID.muted);
    setPAria('mute', PVID.muted ? 'Unmute' : 'Mute');
  }
  function pToggleExpand() {
    var ex = PLR.classList.toggle('is-expanded');
    setPAria('expand', ex ? 'Shrink video' : 'Expand video');
  }
  function pSeek(track, clientX) {
    if (!PVID || !PVID.duration || !isFinite(PVID.duration)) return;
    var r = track.getBoundingClientRect();
    if (!r.width) return;
    var ratio = Math.min(1, Math.max(0, (clientX - r.left) / r.width));
    PVID.currentTime = ratio * PVID.duration;
  }
  function pProgress() {
    if (!PVID || !PFILL) return;
    var d = PVID.duration;
    PFILL.style.width = (d && isFinite(d) ? (PVID.currentTime / d) * 100 : 0) + '%';
  }
  function ensurePlayer() {
    if (PLR) return PLR;
    PLR = document.querySelector('.pi-ugc-player');
    if (!PLR) {
      var tpl = document.querySelector('template[data-pi-ugc-player-tpl]');
      if (!tpl || !tpl.content || !tpl.content.firstElementChild) return null;
      PLR = tpl.content.firstElementChild.cloneNode(true);
      document.body.appendChild(PLR);
    }
    PVID = PLR.querySelector('.pi-ugc-player__video');
    PFILL = PLR.querySelector('.pi-ugc-player__progress-fill');
    if (!PVID) return PLR;

    PLR.addEventListener('click', function (e) {
      if (e.target.closest('.pi-ugc-player__close')) { closePlayer(); return; }
      var seek = e.target.closest('.pi-ugc-player__progress');
      if (seek) { pSeek(seek, e.clientX); return; }
      var btn = e.target.closest('[data-act]');
      if (btn) {
        var act = btn.getAttribute('data-act');
        if (act === 'playpause') pTogglePlay();
        else if (act === 'mute') pToggleMute();
        else if (act === 'expand') pToggleExpand();
        return;
      }
      // Click anywhere on the video (not the control bar) toggles play/pause.
      if (!e.target.closest('.pi-ugc-player__controls')) pTogglePlay();
    });
    PVID.addEventListener('timeupdate', pProgress);
    PVID.addEventListener('play', function () { PLR.classList.remove('is-paused'); setPAria('playpause', 'Pause'); });
    PVID.addEventListener('pause', function () { PLR.classList.add('is-paused'); setPAria('playpause', 'Play'); });
    return PLR;
  }
  function openPlayer(src, poster, opener) {
    if (!src || !ensurePlayer() || !PVID) return;
    POPENER = opener || null;
    if (poster) { PVID.setAttribute('poster', poster); } else { PVID.removeAttribute('poster'); }
    // Attach the source only now (lazy) — swap it if a different tile was opened.
    if (PVID.getAttribute('src') !== src) {
      PVID.setAttribute('src', src);
      try { PVID.load(); } catch (e) {}
    }
    // A tile click is a user gesture, so play WITH sound. If the browser still
    // blocks unmuted playback, fall back to muted so the player is never dead.
    PVID.muted = false;
    PLR.classList.remove('is-paused', 'is-expanded');
    PLR.classList.add('is-unmuted');
    setPAria('mute', 'Mute');
    setPAria('playpause', 'Pause');
    setPAria('expand', 'Expand video');
    if (PFILL) PFILL.style.width = '0%';
    PLR.classList.add('is-open');
    var pr = PVID.play();
    if (pr && pr.catch) pr.catch(function () {
      PVID.muted = true;
      PLR.classList.remove('is-unmuted');
      setPAria('mute', 'Unmute');
      var p2 = PVID.play(); if (p2 && p2.catch) p2.catch(function () {});
    });
    try { PLR.focus(); } catch (e) {}           // move focus into the player
  }
  function closePlayer() {
    if (!PLR || !PLR.classList.contains('is-open')) return;
    PLR.classList.remove('is-open', 'is-expanded');
    if (PVID) {
      try { PVID.pause(); } catch (e) {}
      PVID.removeAttribute('src');
      PVID.removeAttribute('poster');
      try { PVID.load(); } catch (e) {}         // detach + free the buffer
    }
    // Return focus to the tile that opened it, if that tile is still in the DOM.
    if (POPENER && document.contains(POPENER)) { try { POPENER.focus(); } catch (e) {} }
    POPENER = null;
  }
  function wireOpeners(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.pi-ugc-wall__play');
      if (!btn) return;
      e.preventDefault();
      openPlayer(btn.getAttribute('data-clip'), btn.getAttribute('data-poster'), btn);
    });
    if (!escWired) {
      escWired = true;
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') closePlayer();
      });
    }
  }

  function init(root) {
    if (!root || root.dataset.piUgcInit === '1') return;
    root.dataset.piUgcInit = '1';

    // Wire the pop-out openers FIRST — before any reduced-motion / build return —
    // so the static (no-JS / reduced-motion) grid buttons open the player too.
    wireOpeners(root);

    var wall = root.querySelector('[data-pi-ugc-inner]');
    var grid = wall && wall.querySelector('.pi-ugc-wall__grid');
    if (!wall || !grid) return;

    // Reduced motion: leave the static colour masonry grid, never build columns or play.
    if (RM && RM.matches) return;

    var baseCap = parseInt(root.dataset.cap, 10) || 5;
    var pool = Array.prototype.slice.call(grid.children).map(function (n) { return n.cloneNode(true); });
    if (!pool.length) return;

    var io = null, lastCount = 0;

    function detach(v) {
      if (v.getAttribute('src')) {
        try { v.pause(); } catch (e) {}
        v.removeAttribute('src');
        try { v.load(); } catch (e) {}
      }
      var tile = v.closest('.pi-ugc-wall__tile');
      if (tile) tile.classList.remove('is-playing');
    }
    function attachPlay(v) {
      if (!v.getAttribute('src')) {
        var src = v.getAttribute('data-src');
        if (src) { v.setAttribute('src', src); try { v.load(); } catch (e) {} }
      }
      var p = v.play && v.play();
      if (p && p.catch) p.catch(function () {});
      var tile = v.closest('.pi-ugc-wall__tile');
      if (tile) tile.classList.add('is-playing');
    }
    function scheduler() {
      var cap = capFor(baseCap);
      var mid = (window.innerHeight || 800) / 2;
      var vids = Array.prototype.slice.call(wall.querySelectorAll('video[data-visible="1"]'));
      vids.sort(function (a, b) {
        var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
        return Math.abs(ra.top + ra.height / 2 - mid) - Math.abs(rb.top + rb.height / 2 - mid);
      });
      vids.forEach(function (v, i) { if (i < cap) attachPlay(v); else detach(v); });
    }
    function observeAll() {
      if (io) io.disconnect();
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          e.target.setAttribute('data-visible', e.isIntersecting ? '1' : '0');
          if (!e.isIntersecting) detach(e.target);
        });
        scheduler();
      }, { root: null, rootMargin: '100px 0px', threshold: 0.2 });
      wall.querySelectorAll('video').forEach(function (v) { io.observe(v); });
    }

    function build() {
      var prev = wall.querySelector('.pi-ugc-wall__track');
      if (prev) prev.remove();
      grid.style.display = 'none';

      var track = document.createElement('div');
      track.className = 'pi-ugc-wall__track';
      wall.appendChild(track);

      var pps = SPEED[root.dataset.speed] || SPEED.slow;
      var vw = window.innerWidth || 1280;

      // Video + card queues (cycled; repeat as the marquee needs more width).
      var vids = pool.filter(isVideoTile);
      var cards = pool.filter(function (n) { return !isVideoTile(n); });
      if (!vids.length) vids = pool.slice();
      if (!cards.length) cards = pool.slice();
      var vi = 0, ci = 0;
      function nextV() { var n = vids[vi % vids.length].cloneNode(true); vi++; return n; }
      function nextC() { var n = cards[ci % cards.length].cloneNode(true); ci++; return n; }

      // Rotating column sizes (QOVES: mostly 2-tile stacks, some full-height 1s + a 3).
      var COUNTS = [2, 1, 2, 3, 2, 2, 1, 2];

      // Group 1: add columns until the group width comfortably exceeds the viewport.
      var group = document.createElement('div');
      group.className = 'pi-ugc-wall__group';
      track.appendChild(group);
      var idx = 0, guard = 0;
      do {
        group.appendChild(makeCol(COUNTS[idx % COUNTS.length], idx, nextV, nextC));
        idx++; guard++;
      } while (group.getBoundingClientRect().width < vw * 1.6 && guard < 60);

      // Group 2: exact clone for the seamless -50% horizontal loop.
      var g2 = group.cloneNode(true);
      g2.setAttribute('aria-hidden', 'true');
      track.appendChild(g2);

      // One calm px/sec rate: duration = one group's width ÷ speed.
      var gw = group.getBoundingClientRect().width + pxVar(root, '--pi-ugc-gap');
      track.style.animationDuration = (pps > 0 ? gw / pps : 60).toFixed(2) + 's';

      observeAll();
      scheduler();
    }

    build();
    window.addEventListener('scroll', throttle(scheduler, 200), { passive: true });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(build, 220);   // column count depends on viewport width — rebuild
    });
  }

  function boot() { document.querySelectorAll('[data-pi-ugc-wall]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('[data-pi-ugc-wall]');
    if (sec) init(sec);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toolkit-hub"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var root = document.querySelector('[data-tk]');
      if (!root || root.dataset.tkReady) return;
      root.dataset.tkReady = '1';

      var cards   = Array.prototype.slice.call(root.querySelectorAll('.tk__card'));
      var opts    = Array.prototype.slice.call(root.querySelectorAll('.tk__opt'));
      var typeOpts = opts.filter(function (o) { var i = o.querySelector('input'); return i && i.dataset.facet === 'type'; });
      var boxes   = Array.prototype.slice.call(root.querySelectorAll('[data-facet]'));
      var results = root.querySelector('[data-results]');
      var empty   = root.querySelector('[data-empty]');
      var clear   = root.querySelector('[data-clear]');
      var badge   = root.querySelector('[data-active-count]');
      var rail    = root.querySelector('[data-rail]');
      var openBtn = root.querySelector('[data-open-sheet]');
      var applyBtn = root.querySelector('.tk__apply');
      var scrim   = root.querySelector('[data-scrim]');
      var aud     = 'individual';

      function picked(facet) {
        return boxes.filter(function (b) { return b.dataset.facet === facet && b.checked; })
                    .map(function (b) { return b.value; });
      }
      function overlaps(csv, picks) {
        var has = (csv || '').split(' ');
        return picks.some(function (v) { return has.indexOf(v) > -1; });
      }
      // Show only the Type pills that have at least one card on the active
      // audience tab, so no empty/dead pill can be clicked (SCHEMA §4 + per-audience).
      function syncTypes() {
        var present = {};
        cards.forEach(function (c) { if (c.dataset.aud === aud && c.dataset.type) present[c.dataset.type] = 1; });
        typeOpts.forEach(function (o) {
          var input = o.querySelector('input');
          var has = !!present[input.value];
          o.hidden = !has;
          if (!has && input.checked) input.checked = false;
        });
      }
      function apply() {
        var m = picked('moments'), p = picked('products'), ty = picked('type'), t = picked('time'), shown = 0;
        for (var i = 0; i < cards.length; i++) {
          var c = cards[i], ok = c.dataset.aud === aud;
          if (ok && m.length)  ok = overlaps(c.dataset.moments, m);
          if (ok && ty.length) ok = ty.indexOf(c.dataset.type) > -1;
          if (ok && p.length)  ok = overlaps(c.dataset.products, p);
          if (ok && t.length)  ok = t.indexOf(c.dataset.time) > -1;
          c.hidden = !ok;
          if (ok) shown++;
        }
        var n = m.length + p.length + ty.length + t.length;
        var label = shown + (shown === 1 ? ' resource' : ' resources');
        results.textContent = label;
        if (applyBtn) applyBtn.textContent = 'Show ' + label;
        empty.hidden = shown > 0;
        clear.hidden = n === 0;
        badge.hidden = n === 0;
        badge.textContent = n;
      }
      function reset() { boxes.forEach(function (b) { b.checked = false; }); apply(); }

      root.querySelectorAll('.tk__tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
          aud = tab.dataset.aud;
          root.querySelectorAll('.tk__tab').forEach(function (t) {
            var on = t === tab;
            t.classList.toggle('is-on', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          opts.forEach(function (o) {
            if (!o.dataset.forAud) return;
            o.hidden = o.dataset.forAud !== aud;
            if (o.hidden) o.querySelector('input').checked = false;
          });
          syncTypes();
          apply();
        });
      });

      boxes.forEach(function (b) { b.addEventListener('change', apply); });
      if (clear) clear.addEventListener('click', reset);
      var inlineClear = root.querySelector('[data-clear-inline]');
      if (inlineClear) inlineClear.addEventListener('click', reset);

      function openSheet() { rail.classList.add('is-open'); if (scrim) scrim.classList.add('is-open'); if (openBtn) openBtn.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; }
      function closeSheet() { rail.classList.remove('is-open'); if (scrim) scrim.classList.remove('is-open'); if (openBtn) openBtn.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; }
      if (openBtn) openBtn.addEventListener('click', openSheet);
      root.querySelectorAll('[data-close-sheet]').forEach(function (b) { b.addEventListener('click', closeSheet); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });

      syncTypes();
      apply();

      // Deep-link: /pages/career-toolkit?aud=coach (or ?for=educators) opens a
      // pre-filtered audience tab on load. Accepts audience keys + simple plural
      // aliases; an unknown value just leaves the default "For you" tab.
      (function () {
        try {
          var q = new URLSearchParams(window.location.search);
          var want = (q.get('aud') || q.get('for') || '').trim().toLowerCase();
          if (!want) return;
          var alias = { you: 'individual', me: 'individual', individual: 'individual',
            coach: 'coach', coaches: 'coach', educator: 'educator', educators: 'educator',
            manager: 'manager', managers: 'manager' };
          var target = alias[want];
          if (!target || target === aud) return;
          var tab = root.querySelector('.tk__tab[data-aud="' + target + '"]');
          if (tab) tab.click();
        } catch (e) {}
      })();

      /* Sticky-dock the audience bar (desktop). data-stuck via a sentinel; a spacer
         reserves the bar's flow height so content below doesn't jump. */
      var tabsEl  = root.querySelector('[data-tabs]');
      var sentinel = root.querySelector('[data-tabs-sentinel]');
      var spacer  = root.querySelector('[data-tabs-spacer]');
      var mq = window.matchMedia('(min-width: 900px)');
      var flowH = 0;
      function measure() { tabsEl.removeAttribute('data-stuck'); if (spacer) spacer.style.height = '0px'; flowH = tabsEl.offsetHeight; }
      function setStuck(on) {
        if (on && mq.matches) {
          if (spacer) spacer.style.height = flowH + 'px';
          tabsEl.setAttribute('data-stuck', '');
        } else {
          tabsEl.removeAttribute('data-stuck');
          if (spacer) spacer.style.height = '0px';
        }
      }
      if (tabsEl && sentinel && 'IntersectionObserver' in window) {
        measure();
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) setStuck(false);
            else if (en.boundingClientRect.top < 0) setStuck(true);
          });
        }, { threshold: 0 });
        obs.observe(sentinel);
        var rt;
        window.addEventListener('resize', function () {
          clearTimeout(rt);
          rt = setTimeout(function () { if (!mq.matches) setStuck(false); flowH = tabsEl.hasAttribute('data-stuck') ? flowH : tabsEl.offsetHeight; }, 150);
        });
      }
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();
})();
